<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
    >
      <template slot="search" slot-scope="{ row, size }">
        <el-col :span="2"><div class="text-algin:right">金额汇总：</div></el-col>
        <el-col :span="4">
          <el-input
            class="font-color:red"
            v-model="totalAmount"
            placeholder="请输入内容"
            disabled="true"
          ></el-input>
        </el-col>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          icon="el-icon-refresh-right"
          size="small"
          :type="scope.type"
          @click.stop="refund(scope.row, scope.index)"
          >退款</el-button
        ></template
      >
      <template slot-scope="scope" slot="payTypeForm">
        <el-row :span="24">
          <el-col :span="21">
            <el-select v-model="form.payType" placeholder="请选择" :disabled="scope.disabled">
              <el-option
                v-for="item in payTypeDict"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option> </el-select
          ></el-col>
          <el-col :span="3">
            <van-button
              type="default"
              icon="qr"
              size="small"
              class="pay-qrcode"
              :disabled="(form.payType !== 2 && form.payType !== 3) || scope.disabled"
              @click="genearateQrCode"
            ></van-button></el-col
        ></el-row>
      </template>
    </avue-crud>
    <el-dialog
      title="收款码"
      :visible.sync="payInfo2.showQrCode"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center;">
        <div id="qrcodeFeetemppay" ref="qrcode" style="display: inline-block;"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import QRCode from 'qrcodejs2';
import {
  add,
  getDetail,
  getList,
  getTotalAmount,
  loadPayStatus,
  remove,
  saveBarCodePay,
  saveQrCodePay,
  update,
} from '@/api/v4ward/temp/feetemppay';
import { mapGetters } from 'vuex';

export default {
  data() {
    var checkAmount = function (rule, value, callback) {
      if (value <= 0) {
        callback(new Error('金额必须>0'));
      } else {
        callback();
      }
    };
    return {
      payInfo2: {
        showQrCode: false,
        countdown: 120,
        timer: '',
      },
      payTypeDict: [
        { id: 1, label: '现金' },
        { id: 2, label: '微信' },
        { id: 3, label: '支付宝' },
      ],
      returnChannelDict: [
        { id: 1, label: '原路退还' },
        { id: 2, label: '现金退还' },
      ],
      totalAmount: 0,
      form: { payType: null },
      query: {},
      loading: false,
      page: {
        pageSize: 100,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        menuPosition: 'center',
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        align: 'center',
        viewBtn: true,
        editBtn: false,
        delBtn: false,
        menuWidth: 160,
        selection: false,
        dialogHeight: 480,
        saveBtnTitle: '收款',
        updateBtnTitle: '退款',
        cancelBtnTitle: '退出',
        column: [
          {
            label: '临客费用管理表ID',
            prop: 'id',
            hide: true,
            display: false,
            rules: [
              {
                required: true,
                message: '请输入临客费用管理表ID',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '小区',
            prop: 'communityId',
            hide: true,
            viewDisplay: false,
            editDisplay: false,
            search: true,
            type: 'tree',
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
          },
          {
            label: '小区名称',
            prop: 'communityName',
            hide: true,
            addDisplay: false,
            viewDisplay: true,
            disabled: true,
          },
          {
            label: '收费单号',
            prop: 'paybillNo',
            disabled: true,
            placeholder: ' ',
            minWidth: 120,
          },
          {
            label: '临客种类',
            prop: 'custSort',
            hide: true,
            search: true,
            editDisplay: false,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请输入临客种类',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=cust_sort',
          },
          {
            label: '状态',
            prop: 'custPayStatus',
            display: false,
            search: true,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请输入收费状态',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=cust_pay_status',
          },
          {
            label: '临客名称',
            prop: 'custName',
            width: '200',
            search: true,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入临客名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系人',
            prop: 'linkmanName',
            search: true,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入联系人',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系方式',
            prop: 'linkmanPhone',
            hide: true,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入联系方式',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费类型',
            prop: 'custPayType',
            search: true,
            type: 'select',
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入临客收费类型',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=cust_pay_type',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
            type: 'number',
            precision: 2,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入收费金额',
                trigger: 'blur',
              },
              {
                validator: checkAmount,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费方式',
            prop: 'payType',
            search: false,
            formslot: true,
            editDisabled: true,
            viewDisabled: true,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择收费方式',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'label',
              value: 'id',
            },
            dicData: [
              { id: 1, label: '现金' },
              { id: 2, label: '微信' },
              { id: 3, label: '支付宝' },
            ],
          },
          {
            label: '收费时间',
            prop: 'payTime',
            display: false,
            search: true,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 150,
            searchSpan: 12,
            rules: [
              {
                required: true,
                message: '请输入收费时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '付款码',
            prop: 'authCode',
            hide: true,
            viewDisplay: false,
            editDisplay: false,
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
            hide: true,
            editDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入票据号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费原因',
            prop: 'payRemark',
            span: 24,
            editDisabled: true,
          },
          {
            label: '收费员',
            prop: 'cashier',
            display: false,
            rules: [
              {
                required: true,
                message: '请输入收银员',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '退款渠道',
            prop: 'returnChannel',
            hide: true,
            type: 'select',
            addDisplay: false,
            editDisplay: true,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入退款渠道',
                trigger: 'blur',
              },
            ],
            props: {
              label: 'label',
              value: 'id',
            },
            dicData: [
              { id: 1, label: '原路退还' },
              { id: 2, label: '现金退还' },
            ],
          },
          {
            label: '退费原因',
            prop: 'returnRemark',
            span: 24,
            hide: true,
            addDisplay: false,
            editDisplay: true,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入退费原因',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feetemppay_add, false),
        viewBtn: this.vaildData(this.permission.feetemppay_view, false),
        delBtn: this.vaildData(this.permission.feetemppay_delete, false),
        editBtn: this.vaildData(this.permission.feetemppay_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    //退款弹框
    refund(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    //点击收款 现金直接提交，付款码先下单再保存数据
    rowSave(row, loading, done) {
      //现金直接保存
      if (row.payType === 1) {
        add(row).then(
          () => {
            loading();
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else if (row.payType === 2 || row.payType === 3) {
        saveBarCodePay(this.form, { showLoading: { text: '收款中' } }).then(
          ({ data }) => {
            loading();
            this.form.paybillNo = data.paybillNo;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    //退款提交
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      // this.onLoad(this.page);
    },
    searchChange(params, done) {
      if (params.communityId == null || params.communityId === '') {
        this.$message.warning('请选择小区!');
        return false;
      }

      let payTimeQuery = { payTimeS: '', payTimeE: '' };
      if ('' !== params.payTime && null != params.payTime && 'undefined' !== params.payTime) {
        payTimeQuery = { payTimeS: params.payTime[0], payTimeE: params.payTime[1] };
      }

      this.query = Object.assign(params, payTimeQuery);
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page, this.query);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
      getTotalAmount(Object.assign(params, this.query)).then((res) => {
        this.totalAmount = res.data;
      });
    },
    genearateQrCode() {
      console.log(this.form);
      this.$refs.crud.validate((valid) => {
        //验证成功
        if (valid) {
          saveQrCodePay(this.form, { showLoading: { text: '正在获取二维码' } }).then(({ data }) => {
            this.payInfo2.showQrCode = true;
            this.form.paybillNo = data.paybillNo;
            this.$nextTick(() => {
              new QRCode('qrcodeFeetemppay', {
                width: 250,
                height: 250,
                text: data.codeUrl,
              });
            });
            this.payInfo2.countdown = 120;
            this.payInfo2.timer = setInterval(() => {
              if (this.payInfo2.countdown === 0) {
                clearInterval(this.payInfo2.timer);
                this.payInfo2.showQrCode = false;
                this.$message.error('二维码已超时，请刷新后重新操作!');
              }
              if (this.payInfo2.countdown % 5 === 0) {
                loadPayStatus({ paybillNo: this.form.paybillNo }).then(({ data }) => {
                  if (data.tradeStatus === 2) {
                    clearInterval(this.payInfo2.timer);
                    this.payInfo2.showQrCode = false;
                    this.$message.success('支付成功');
                    //直接关闭新增对话框
                    this.$refs.crud.$refs.dialogForm.closeDialog();
                  }
                });
              }
              this.payInfo2.countdown--;
            }, 1000);
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
.pay-qrcode {
  float: left;
  min-width: 0;
  padding: 0;
  font-size: 28px;
}
</style>
